import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealConstructionItem } from "~/models/DealConstructionItem";
import { generatePath } from "~/utils/generatePath";

export const useDealConstructionItems = (
	dealId: number | null
): SwrReturnType<DealConstructionItem[]> => {
	const path = dealId
		? generatePath("/vendors/deals/:deal_id/deal_construction_items", {
				deal_id: dealId
			})
		: null;

	const { data, mutate, error, isLoading } =
		useSWR<DealConstructionItem[]>(path);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
